export default __webpack_public_path__ + "static/media/undo.9cd38d89.svg";